<div class="slider w-full select-none grid grid-cols-2 grid-rows-1 align-middle"
     style="grid-template-columns: auto min-content;">
  <input [ngClass]="{'bg-gray-200':!mouseOver, '':mouseOver}" [ngStyle]="{'--track-width': percent+'%'}"
         disabled="disabled"
         class="[&::-webkit-slider-thumb]:bg-fuchsia-700 pointer-events-none {{classes}} my-auto w-full col-start-1"
         type="range" [min]="0" [max]="1" [value]="0">
  <span class="col-start-2  ml-4 my-auto font-light">{{ percent | number: '1.2-2' }}%</span>
</div>
